import React from 'react'

import { cn } from '@/utilities/ui'

export type HeroMediaOverlayTone = 'landing' | 'city' | 'location'

type HeroMediaOverlayProps = {
  tone?: HeroMediaOverlayTone
}

export function HeroMediaOverlay({ tone = 'city' }: HeroMediaOverlayProps) {
  const isLocation = tone === 'location'

  return (
    <div
      aria-hidden
      className={cn(
        'pointer-events-none absolute inset-0 z-[1]',
        isLocation ? 'hero-overlay-video-bottom--location' : 'hero-overlay-video-bottom',
      )}
    />
  )
}
